module.exports = __webpack_public_path__ + "static/img/sl-groupphoto.3beb723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/selfHelpFilingProject/images/sl-groupphoto.jpg
// module id = pjo8
// module chunks = 5